import React, { useEffect, useState } from "react";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";
import { CircularProgress, Box, Typography } from "@mui/material";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      console.log("🔒 ProtectedRoute - Auth state:", user?.email);
      if (!user) {
        console.log("❌ No user, redirecting to login");
        navigate("/login", { replace: true });
      }
      setChecking(false);
    });

    return unsubscribe;
  }, [navigate]);

  if (checking) {
    return (
      <Box sx={{ textAlign: "center", mt: 10 }}>
        <CircularProgress />
        <Typography sx={{ mt: 2 }}>Checking authentication...</Typography>
      </Box>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;